import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { useFormBackup } from '@app/lib/cache/FormBackup/useFormBackup'

export type FormBackupProps = {
  uid: string
}

export const FormBackup = ({ uid }: FormBackupProps) => {
  const { backup } = useFormBackup({
    uid
  })

  const { watch } = useFormContext()

  const values = watch()

  useEffect(() => {
    backup(values)
  }, [values])

  return null
}
